import { getNgService } from '../utils/utils';

/**
 * Runs `fn` inside an AngularJS digest. Called from a React handler, a $q chain (and
 * the $http request behind it) would otherwise wait for whatever digest comes next.
 */
const inDigest = (fn: () => void) => {
  getNgService('$rootScope').$evalAsync(fn);
};

/** Opens one of the shell's $mdDialog confirmations; resolves false when dismissed */
export const confirmInShell = (service: string, method: string): Promise<boolean> =>
  new Promise((resolve) => {
    try {
      inDigest(() => {
        getNgService(service)
          [method]()
          .then(
            () => resolve(true),
            () => resolve(false)
          );
      });
    } catch (e) {
      resolve(false);
    }
  });

/** Copies saved values onto the company space the shell keeps cached (header, forms) */
export const syncShellCompanySpace = (values: Record<string, unknown>) => {
  try {
    inDigest(() => {
      getNgService('companySpaceManager')
        .currentCompanySpace.take(1)
        .subscribe((space: Record<string, unknown>) => Object.assign(space, values));
    });
  } catch (e) {
    // no shell around (tests, standalone dev server)
  }
};

/** Writes a search param of the current state without reloading it (needs reloadOnSearch: false) */
export const setShellStateParam = (name: string, value: string) => {
  try {
    inDigest(() => {
      getNgService('$state').go('.', { [name]: value }, { notify: false, location: 'replace' });
    });
  } catch (e) {
    // no shell around
  }
};
